module.exports = __webpack_public_path__ + "static/media/division.6acc7a3a.svg";